<template>
    <div class="page" id="mixed-notes">
        <div class="decorative-texture top">
            <img :src="require(`@/assets/img/texture.png`)" />
        </div>
        <div class="decorative-texture position-bottom movil-only">
            <img :src="require(`@/assets/img/texture.png`)" />
        </div>
        <vue-snotify></vue-snotify>
        <side-menu :menuOn="menuOn" @menuVisible="menuVisible"></side-menu>
        <mnavbar @menuVisible="menuVisible"></mnavbar>

        <div id="wrapper" :class="[{ 'active': hide }]">
            <!-- Sidebar -->
            <div id="sidebar-wrapper" :class="[{ 'top0': classTop }]">
                <nav>
                    <ul class="sidebar-nav">
                        <li class="sidebar-brand">
                            <a href="#" @click.prevent="() => { }"><span>Mis Búsquedas</span></a>
                        </li>
                        <li v-for="(b, index) in busquedas" :key="b.key">
                            <a :class="[{ 'selected': customSearch.key == b.key }]" href="#"
                                @click.prevent="selectSearch(b, index,true)">
                                <svg v-if="b.query.alerta" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" class="feather feather-bell">
                                    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                                    <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                                </svg>

                                <!-- https://feathericons.dev/?search=whatsapp&iconset=brands -->
                                <svg v-if="b.query.alertWP" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="22" height="22" class="main-grid-item-icon" fill="none">
                                <path d="M6.579 8.121c.209-.663.778-1.457 1.19-1.66.183-.09.319-.11.763-.11.522 0 .548.005.684.14.088.095.328.606.673 1.432.292.71.533 1.315.533 1.347 0 .146-.293.61-.627 1.002-.23.267-.365.47-.365.543 0 .068.167.381.376.69.506.757 1.44 1.696 2.167 2.177.568.376 1.582.867 1.785.867.152 0 .429-.272.992-.982.23-.287.434-.495.512-.511.068-.021.235.005.37.057.392.152 2.371 1.117 2.476 1.211.203.188.037 1.264-.267 1.702-.464.68-1.79 1.259-2.663 1.17-.636-.068-2.14-.564-3.117-1.029-1.253-.6-2.574-1.697-3.644-3.038-.611-.763-1.227-1.692-1.493-2.246-.36-.751-.491-1.331-.455-2 .016-.287.068-.631.11-.762Z" fill="#ffffff" />
                                <path clip-rule="evenodd" d="M.606 9.5C1.582 4.491 5.576.76 10.709.06c.705-.1 2.684-.068 3.368.046.715.126 1.66.371 2.24.59 3.832 1.426 6.663 4.72 7.466 8.683.35 1.729.272 3.755-.203 5.457-1.133 4.03-4.423 7.205-8.511 8.218-2.663.658-5.462.37-7.983-.81l-.617-.292-3.226 1.029C1.473 23.545.01 23.994 0 23.983c-.01-.01.45-1.415 1.029-3.112l1.05-3.096-.424-.84C.48 14.569.12 12.01.605 9.498Zm21.172-.408c-1.028-3.76-4.297-6.626-8.145-7.148-2.099-.282-4.078.037-5.9.956-4.417 2.234-6.522 7.341-4.93 11.957.204.59.752 1.702 1.092 2.213l.271.408-.605 1.775a69.688 69.688 0 0 0-.606 1.817c0 .026.84-.224 1.864-.548a99.767 99.767 0 0 1 1.9-.596c.022 0 .225.11.45.24 2.428 1.447 5.456 1.76 8.187.852a9.927 9.927 0 0 0 6.48-6.945 9.998 9.998 0 0 0-.058-4.98Z" fill="#ffffff" fill-rule="evenodd" />
                                </svg>

                                <span>
                                    {{ getKeywords(b.query.keywords) }}
                                </span>
                                <span class="icons" v-for="fi in getFis(b.query)" :key="fi">
                                    <svg v-if="fi == 'FB'" width="20px" height="20px" viewBox="0 0 24 24">
                                        <path
                                            d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m13 2h-2.5A3.5 3.5 0 0 0 12 8.5V11h-2v3h2v7h3v-7h3v-3h-3V9a1 1 0 0 1 1-1h2V5z" />
                                    </svg>
                                    <svg v-if="fi == 'TW'" xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false"
                                        width="20px" height="20px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 4600 4600">
                <path d="M0 4579 c-2 -3 160 -224 359 -490 199 -266 622 -832 940 -1257 l578
        -773 -37 -42 c-21 -23 -446 -482 -944 -1020 -498 -539 -907 -983 -908 -988 -2
        -5 85 -9 210 -8 l213 1 70 77 c39 42 401 433 805 870 404 437 746 807 760 823
        l25 29 200 -268 c110 -147 413 -553 673 -901 l474 -632 725 0 c603 0 724 2
        720 13 -3 8 -187 256 -409 553 -222 296 -476 636 -564 754 -89 118 -350 469
        -582 778 -232 310 -422 568 -422 572 0 7 1226 1338 1643 1783 l119 127 -219 0
        -218 -1 -255 -276 c-140 -152 -483 -524 -763 -825 l-507 -548 -615 822 -616
        823 -725 5 c-399 3 -728 2 -730 -1z m1718 -886 c237 -318 603 -807 813 -1088
        210 -280 676 -904 1036 -1385 360 -482 658 -881 663 -888 6 -9 -65 -12 -324
        -12 l-331 0 -656 878 c-1514 2023 -2278 3045 -2287 3060 -6 9 62 12 323 12
        l331 0 432 -577z" />
                                    </svg>
                                    <svg v-if="fi == 'T'" xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="20px" height="20px"
                                        viewBox="0 0 24 24">
                                        <path
                                            d="M8.16,3L6.75,4.41L9.34,7H4C2.89,7 2,7.89 2,9V19C2,20.11 2.89,21 4,21H20C21.11,21 22,20.11 22,19V9C22,7.89 21.11,7 20,7H14.66L17.25,4.41L15.84,3L12,6.84L8.16,3M4,9H17V19H4V9M19.5,9A1,1 0 0,1 20.5,10A1,1 0 0,1 19.5,11A1,1 0 0,1 18.5,10A1,1 0 0,1 19.5,9M19.5,12A1,1 0 0,1 20.5,13A1,1 0 0,1 19.5,14A1,1 0 0,1 18.5,13A1,1 0 0,1 19.5,12Z" />
                                    </svg>
                                    <svg v-if="fi == 'R'" xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false"
                                        width="20px" height="20px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                                        <path
                                            d="M12 10a2 2 0 0 1 2 2a2 2 0 0 1-.47 1.29L16.7 22h-2.13L12 14.93L9.43 22H7.3l3.17-8.71A2 2 0 0 1 10 12a2 2 0 0 1 2-2m0-2a4 4 0 0 0-4 4c0 .5.1 1 .28 1.46l-.88 2.4A6.026 6.026 0 0 1 6 12a6 6 0 0 1 6-6a6 6 0 0 1 6 6c0 1.47-.53 2.81-1.4 3.86l-.88-2.4C15.9 13 16 12.5 16 12a4 4 0 0 0-4-4m0-4a8 8 0 0 0-8 8c0 2.36 1 4.5 2.64 5.94l-.72 2A10.005 10.005 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10c0 3.23-1.54 6.11-3.92 7.94l-.72-2C19 16.5 20 14.36 20 12a8 8 0 0 0-8-8z" />
                                    </svg>
                                    <svg v-if="fi == 'Y'" xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false"
                                        width="20px" height="20px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                                        <path
                                            d="M10 15l5.19-3L10 9v6m11.56-7.83c.13.47.22 1.1.28 1.9c.07.8.1 1.49.1 2.09L22 12c0 2.19-.16 3.8-.44 4.83c-.25.9-.83 1.48-1.73 1.73c-.47.13-1.33.22-2.65.28c-1.3.07-2.49.1-3.59.1L12 19c-4.19 0-6.8-.16-7.83-.44c-.9-.25-1.48-.83-1.73-1.73c-.13-.47-.22-1.1-.28-1.9c-.07-.8-.1-1.49-.1-2.09L2 12c0-2.19.16-3.8.44-4.83c.25-.9.83-1.48 1.73-1.73c.47-.13 1.33-.22 2.65-.28c1.3-.07 2.49-.1 3.59-.1L12 5c4.19 0 6.8.16 7.83.44c.9.25 1.48.83 1.73 1.73z" />
                                    </svg>
                                    <svg v-if="fi == 'TK'" xmlns="http://www.w3.org/2000/svg" width="18px" height="18px"
                                        viewBox="0 0 34 34">
                                        <path
                                            d="M16.708 0.027c1.745-0.027 3.48-0.011 5.213-0.027 0.105 2.041 0.839 4.12 2.333 5.563 1.491 1.479 3.6 2.156 5.652 2.385v5.369c-1.923-0.063-3.855-0.463-5.6-1.291-0.76-0.344-1.468-0.787-2.161-1.24-0.009 3.896 0.016 7.787-0.025 11.667-0.104 1.864-0.719 3.719-1.803 5.255-1.744 2.557-4.771 4.224-7.88 4.276-1.907 0.109-3.812-0.411-5.437-1.369-2.693-1.588-4.588-4.495-4.864-7.615-0.032-0.667-0.043-1.333-0.016-1.984 0.24-2.537 1.495-4.964 3.443-6.615 2.208-1.923 5.301-2.839 8.197-2.297 0.027 1.975-0.052 3.948-0.052 5.923-1.323-0.428-2.869-0.308-4.025 0.495-0.844 0.547-1.485 1.385-1.819 2.333-0.276 0.676-0.197 1.427-0.181 2.145 0.317 2.188 2.421 4.027 4.667 3.828 1.489-0.016 2.916-0.88 3.692-2.145 0.251-0.443 0.532-0.896 0.547-1.417 0.131-2.385 0.079-4.76 0.095-7.145 0.011-5.375-0.016-10.735 0.025-16.093z" />
                                    </svg>
                                    <!--  <svg
                                        v-if="fi=='I'"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                        aria-hidden="true"
                                        focusable="false"
                                        width="20px"
                                        height="20px"
                                        preserveAspectRatio="xMidYMid meet"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                        d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8A1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3z"
                                        />
                                    </svg>
                                    <svg v-if="fi=='PD'"  width="20px"
                                        height="20px"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                                        <path
                                        d="M552 64H88c-13.255 0-24 10.745-24 24v8H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h472c26.51 0 48-21.49 48-48V88c0-13.255-10.745-24-24-24zM56 400a8 8 0 0 1-8-8V144h16v248a8 8 0 0 1-8 8zm236-16H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm-208-96H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm0-96H140c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h360c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12z"
                                        />
                                    </svg> -->

                                </span>
                            </a>
                        </li>
                        <li class="end" v-if="LastEvaluatedKey2">
                            <div class="button-circle-more secondary noMargin">
                                <button class="button circle-more tooltip " data-tooltip="cargar más" @click="getSearches">
                                    <svg viewBox="0 0 18 18">
                                        <g id="Grupo_29" data-name="Grupo 29" transform="translate(-171 -753)">
                                            <rect id="Rectángulo_redondeado_903" data-name="Rectángulo redondeado 903"
                                                width="2" height="18" rx="1" transform="translate(179 753)" fill="#fff" />
                                            <rect id="Rectángulo_redondeado_903_copia"
                                                data-name="Rectángulo redondeado 903 copia" width="18" height="2" rx="1"
                                                transform="translate(171 761)" fill="#fff" />
                                        </g>
                                    </svg>
                                </button>
                            </div>
                            <!-- END BUTTON CIRCLE -->
                        </li>
                    </ul>
                </nav>

            </div>
            <!-- Page content -->
            <div id="page-content-wrapper">

                <!-- vista para nueva busqueda  -->
                <div class="container-fluid noPadding" v-if="customIndexSearch < 0 || editing == true">
                    <div class="toolBar">
                        <div class="row">
                            <div class="col">
                                <h2 class="toolBarTitle">
                                    <button :class="['button', 'buttonTool', 'tooltip', { 'oculto': menuOn }]"
                                        :data-tooltip="label" @click="hideSearches">
                                        <font-awesome-icon :icon="flecha" />
                                    </button>
                                    Busqueda
                                </h2>
                            </div><!-- col --->
                            <div class="toolActions col-auto ">
                                <div class="separator"></div>
                                <div class="keywords">
                                    <button class="button buttonTool tooltip" data-tooltip="Nueva Búsqueda"
                                        @click="newSearch">
                                        <font-awesome-icon icon="plus" />
                                    </button>
                                </div><!-- keywords buttons -->
                            </div><!-- toolActions -->
                        </div><!-- row -->
                    </div><!-- toolBar -->
                    <div class="row justify-content-center">
                        <div
                            :class="['col-sm-12', { 'col-md-12': !hide }, { 'col-md-10': hide }, { 'col-lg-12': !hide }, { 'col-lg-10': hide }, { 'col-xl-8': !hide }, { 'col-xl-7': hide }]">
                            <search :search="customSearch" @update="update" @buscar="buscar" @error="error"
                                @success="success"></search>
                        </div>
                    </div>
                </div>
                <!-- vista para visualización de notas  -->
                <section class="noPadding" v-else>
                    <div class="toolBar">
                        <div class="row">
                            <div class="col-xs-12 col-sm-3 col-md-3 col-lg-2 col-xl-3">
                                <h2 class="toolBarTitle">
                                    <button :class="['button', 'buttonTool', 'tooltip', { 'oculto': menuOn }]"
                                        :data-tooltip="label" @click="hideSearches">
                                        <font-awesome-icon :icon="flecha" />
                                    </button>
                                    {{ getKeywords(customSearch.query.keywords) + getTotalLabel() }}
                                </h2>
                            </div><!-- col --->


                            <div class="col-xs-12 col-sm-1 col-md-2 col-lg-3 col-xl-4 text-center">
                                <label class="sub">
                                    <span class="icons iconsTitle" v-for="fi in getFis(customSearch.query)"
                                        :key="'title-' + fi">
                                        <svg v-if="fi == 'FB'" width="20px" height="20px" viewBox="0 0 24 24">
                                            <path
                                                d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m13 2h-2.5A3.5 3.5 0 0 0 12 8.5V11h-2v3h2v7h3v-7h3v-3h-3V9a1 1 0 0 1 1-1h2V5z" />
                                        </svg>
                                        <svg v-if="fi == 'TW'" xmlns="http://www.w3.org/2000/svg"
                                            xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false"
                                            width="20px" height="20px" preserveAspectRatio="xMidYMid meet"
                                            viewBox="0 0 4500 4500">
                <path d="M0 4579 c-2 -3 160 -224 359 -490 199 -266 622 -832 940 -1257 l578
        -773 -37 -42 c-21 -23 -446 -482 -944 -1020 -498 -539 -907 -983 -908 -988 -2
        -5 85 -9 210 -8 l213 1 70 77 c39 42 401 433 805 870 404 437 746 807 760 823
        l25 29 200 -268 c110 -147 413 -553 673 -901 l474 -632 725 0 c603 0 724 2
        720 13 -3 8 -187 256 -409 553 -222 296 -476 636 -564 754 -89 118 -350 469
        -582 778 -232 310 -422 568 -422 572 0 7 1226 1338 1643 1783 l119 127 -219 0
        -218 -1 -255 -276 c-140 -152 -483 -524 -763 -825 l-507 -548 -615 822 -616
        823 -725 5 c-399 3 -728 2 -730 -1z m1718 -886 c237 -318 603 -807 813 -1088
        210 -280 676 -904 1036 -1385 360 -482 658 -881 663 -888 6 -9 -65 -12 -324
        -12 l-331 0 -656 878 c-1514 2023 -2278 3045 -2287 3060 -6 9 62 12 323 12
        l331 0 432 -577z" />
                                        </svg>
                                        <svg v-if="fi == 'T'" xmlns="http://www.w3.org/2000/svg"
                                            xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="20px"
                                            height="20px" viewBox="0 0 24 24">
                                            <path
                                                d="M8.16,3L6.75,4.41L9.34,7H4C2.89,7 2,7.89 2,9V19C2,20.11 2.89,21 4,21H20C21.11,21 22,20.11 22,19V9C22,7.89 21.11,7 20,7H14.66L17.25,4.41L15.84,3L12,6.84L8.16,3M4,9H17V19H4V9M19.5,9A1,1 0 0,1 20.5,10A1,1 0 0,1 19.5,11A1,1 0 0,1 18.5,10A1,1 0 0,1 19.5,9M19.5,12A1,1 0 0,1 20.5,13A1,1 0 0,1 19.5,14A1,1 0 0,1 18.5,13A1,1 0 0,1 19.5,12Z" />
                                        </svg>
                                        <svg v-if="fi == 'R'" xmlns="http://www.w3.org/2000/svg"
                                            xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false"
                                            width="20px" height="20px" preserveAspectRatio="xMidYMid meet"
                                            viewBox="0 0 24 24">
                                            <path
                                                d="M12 10a2 2 0 0 1 2 2a2 2 0 0 1-.47 1.29L16.7 22h-2.13L12 14.93L9.43 22H7.3l3.17-8.71A2 2 0 0 1 10 12a2 2 0 0 1 2-2m0-2a4 4 0 0 0-4 4c0 .5.1 1 .28 1.46l-.88 2.4A6.026 6.026 0 0 1 6 12a6 6 0 0 1 6-6a6 6 0 0 1 6 6c0 1.47-.53 2.81-1.4 3.86l-.88-2.4C15.9 13 16 12.5 16 12a4 4 0 0 0-4-4m0-4a8 8 0 0 0-8 8c0 2.36 1 4.5 2.64 5.94l-.72 2A10.005 10.005 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10c0 3.23-1.54 6.11-3.92 7.94l-.72-2C19 16.5 20 14.36 20 12a8 8 0 0 0-8-8z" />
                                        </svg>
                                        <svg v-if="fi == 'Y'" xmlns="http://www.w3.org/2000/svg"
                                            xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false"
                                            width="20px" height="20px" preserveAspectRatio="xMidYMid meet"
                                            viewBox="0 0 24 24">
                                            <path
                                                d="M10 15l5.19-3L10 9v6m11.56-7.83c.13.47.22 1.1.28 1.9c.07.8.1 1.49.1 2.09L22 12c0 2.19-.16 3.8-.44 4.83c-.25.9-.83 1.48-1.73 1.73c-.47.13-1.33.22-2.65.28c-1.3.07-2.49.1-3.59.1L12 19c-4.19 0-6.8-.16-7.83-.44c-.9-.25-1.48-.83-1.73-1.73c-.13-.47-.22-1.1-.28-1.9c-.07-.8-.1-1.49-.1-2.09L2 12c0-2.19.16-3.8.44-4.83c.25-.9.83-1.48 1.73-1.73c.47-.13 1.33-.22 2.65-.28c1.3-.07 2.49-.1 3.59-.1L12 5c4.19 0 6.8.16 7.83.44c.9.25 1.48.83 1.73 1.73z" />
                                        </svg>
                                        <svg v-if="fi == 'TK'" xmlns="http://www.w3.org/2000/svg" width="18px" height="18px"
                                            viewBox="0 0 32 32">
                                            <path
                                                d="M16.708 0.027c1.745-0.027 3.48-0.011 5.213-0.027 0.105 2.041 0.839 4.12 2.333 5.563 1.491 1.479 3.6 2.156 5.652 2.385v5.369c-1.923-0.063-3.855-0.463-5.6-1.291-0.76-0.344-1.468-0.787-2.161-1.24-0.009 3.896 0.016 7.787-0.025 11.667-0.104 1.864-0.719 3.719-1.803 5.255-1.744 2.557-4.771 4.224-7.88 4.276-1.907 0.109-3.812-0.411-5.437-1.369-2.693-1.588-4.588-4.495-4.864-7.615-0.032-0.667-0.043-1.333-0.016-1.984 0.24-2.537 1.495-4.964 3.443-6.615 2.208-1.923 5.301-2.839 8.197-2.297 0.027 1.975-0.052 3.948-0.052 5.923-1.323-0.428-2.869-0.308-4.025 0.495-0.844 0.547-1.485 1.385-1.819 2.333-0.276 0.676-0.197 1.427-0.181 2.145 0.317 2.188 2.421 4.027 4.667 3.828 1.489-0.016 2.916-0.88 3.692-2.145 0.251-0.443 0.532-0.896 0.547-1.417 0.131-2.385 0.079-4.76 0.095-7.145 0.011-5.375-0.016-10.735 0.025-16.093z" />
                                        </svg>
                                        <!--  <svg
                                            v-if="fi=='I'"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlns:xlink="http://www.w3.org/1999/xlink"
                                            aria-hidden="true"
                                            focusable="false"
                                            width="20px"
                                            height="20px"
                                            preserveAspectRatio="xMidYMid meet"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                            d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8A1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3z"
                                            />
                                        </svg>
                                        <svg v-if="fi=='PD'"  width="20px"
                                            height="20px"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                                            <path
                                            d="M552 64H88c-13.255 0-24 10.745-24 24v8H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h472c26.51 0 48-21.49 48-48V88c0-13.255-10.745-24-24-24zM56 400a8 8 0 0 1-8-8V144h16v248a8 8 0 0 1-8 8zm236-16H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm-208-96H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm0-96H140c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h360c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12z"
                                            />
                                        </svg>-->

                                    </span>
                                </label><br>
                                <label class="sub"> {{ getFechas() }} </label><br>
                                <label class="sub" v-if="customSearch.query.hora">{{ customSearch.query.hora.ini }} -
                                    {{ customSearch.query.hora.fin }}</label>
                            </div>
                            <div class="col-xs-12 col-sm-8 col-md-7 col-lg-7 col-xl-5 toolActions">
                                <div class="mi-select">
                                    <v-select :value="options[view - 1]" :reduce="option => option.value"
                                        :searchable="false" :filterable="false" :clearable="false" class="style-chooser"
                                        :options="options" @input="setSelected">
                                    </v-select>
                                </div>
                                <button class="button buttonTool tooltip" data-tooltip="Eliminar Búsqueda"
                                    @click="borrarBusqueda">
                                    <font-awesome-icon icon="trash" />
                                </button>
                                <button class="button buttonTool tooltip" data-tooltip="Editar Búsqueda"
                                    @click="editarBusqueda">
                                    <font-awesome-icon icon="edit" />
                                </button>
                                <button class="button buttonTool tooltip" @click="exportFile" data-tooltip="Exportar">
                                    <font-awesome-icon icon="cloud-download-alt" />
                                </button>
                                <div class="separator" style="max-height:40px;"></div>
                                <button class="button buttonTool tooltip" data-tooltip="Agregar a Carpeta"
                                    @click="saveNotes">
                                    <font-awesome-icon icon="folder-plus" />
                                </button>
                                <button class="button buttonTool tooltip" data-tooltip="Enviar" @click="enviar"
                                    v-if="!isEmpty">
                                    <font-awesome-icon icon="paper-plane" />
                                </button>
                                <div class="keywords">
                                    <button class="button buttonTool tooltip" data-tooltip="Nueva Búsqueda"
                                        @click="newSearch">
                                        <font-awesome-icon icon="plus" />
                                    </button>
                                </div><!-- keywords buttons -->
                            </div><!-- toolActions -->
                        </div><!-- row -->
                    </div><!-- toolBar -->
                    <panel-notas v-if="view == 1" :items="items" :LastEvaluatedKey="LastEvaluatedKey" @goToNote="goToNote"
                        @goToNotes="goToNotes" @loadMore="loadMore"></panel-notas>
                    <panel-text v-if="view == 2" :items="items" :LastEvaluatedKey="LastEvaluatedKey" @goToNote="goToNote"
                        @goToNotse="goToNotes" @loadMore="loadMore"></panel-text>
                    <timeline v-if="view == 3" :items="items" :LastEvaluatedKey="LastEvaluatedKey"
                        @goToNoteTimeline="goToNote" @goToNotes="goToNotes" @loadMore="loadMore"></timeline>
                        <!--//INICIALES-DEV-->
                     <timelinefull v-if="view == 4 && !isEmpty" :items="items" :LastEvaluatedKey="LastEvaluatedKey" 
                        @goToNoteTimeline="goToNote" @goToNotes="goToNotes" @loadMore="loadMore">
                    </timelinefull>
                        
                    <empty-page title="No Hay Notas" v-if="isEmpty"></empty-page>
                    <confirm :show="show" :smsModal="smsModal" @aceptar="deleteSearch" @cancelar="cancelDelete"></confirm>
                </section>
            </div>
        </div>
        <export-file :isActive="isActive" @closeModal="closeModal" @exportCSV="exportCSV"></export-file>
        <email-alert :show="emailModal" subject @enviar="sendEmail" @cancelarEnviar="cancelarEnviar"
            @error="error"></email-alert>
    </div>
</template>

<script>
import SideMenu from '@/components/sideMenu'
import mnavbar from '@/components/mnavbar'
import search from "@/components/search";
import timelinefull from "@/components/timelinefull"
import panelNotas from "@/components/panelNotas";
import panelText from "@/components/panelText";
import timeline from "@/components/timeline";

import emptyPage from "@/components/emptyPage";
import confirm from "@/components/confirm";
import exportFile from "@/components/exportFile";
import emailAlert from "@/components/emailAlert";


import busquedaCompleta from "@/pages/WizzardBusqueda";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
    faPlus,
    faCaretRight,
    faCaretLeft,
    faTrash,
    faCloudDownloadAlt,
    faFolderPlus,
    faPaperPlane,
    faEdit
} from "@fortawesome/free-solid-svg-icons";

import moment from "moment-timezone";

library.add(faPlus)
library.add(faCaretRight)
library.add(faCaretLeft)
library.add(faCloudDownloadAlt);
library.add(faTrash);
library.add(faFolderPlus);
library.add(faPaperPlane);
library.add(faEdit);

export default {
    components: {
        mnavbar,
        SideMenu,
        search,
        panelNotas,
        panelText,
        timeline,
        confirm,
        exportFile,
        emailAlert,
        busquedaCompleta,
        emptyPage,
        timelinefull
    },
    data() {
        return {
            //sidemenu
            url: this.$store.getters.getMainUrl,
            menuOn: false,
            notificationstatus : false,
            //sidemenu (busquedas)
            hide: false,
            classTop: false,
            flecha: "caret-left",
            label: "Ocultar Búsquedas",
            //axios
            url: this.$store.getters.getMainUrl,
            providerID: this.$store.state.userInfo.net,
            // historial de busquedas
            busquedas: [],
            LastEvaluatedKey2: null,
            customSearch: {},
            customIndexSearch: -1,
            //notas
            items: [],
            LastEvaluatedKey: 0,
            total: 0,
            limit: 18,
            isEmpty: false,
            //selectnotas
            options: [{ label: 'Modo Gráfico', value: 1 }, { label: 'Modo Texto', value: 2 }, { label: 'Escaleta', value: 3 },{ label: 'Completo', value: 4 }],
            view: 3,
            from2: '',
            //confirmDelete
            show: false,
            smsModal: "¿Desea eliminar ésta búsqueda?",
            //exportFile
            isActive: false,
            //email
            emailModal: false,
            editing: false,
            mode: 1, //1:fast,2:especific fi,
                /////INICIALES-DEV
            
        }
    },
    computed: {
        
        token() {
            return this.$store.getters.getToken;
        },
        selectedSearch() {
            return this.$store.getters.getSelectedSearch;
        }
    },
    
    beforeMount() {
       
        this.$store.commit('clearProyectConfig');
        this.$store.commit('clearNotificationWhatsApp');
        this.getSearches();
    },
    created: function () {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed: function () {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        
        getSearches() {
            var self = this;
            var post_data = {
                token: this.token,
                limit: 20
            };
            if (this.LastEvaluatedKey2 != null) post_data['LastEvaluatedKey'] = this.LastEvaluatedKey2;

            axios.post(self.url + "getSearches", JSON.stringify(post_data))
                .then(function (response) {
                    if (self.busquedas.length == 0) {
                        self.busquedas = response.data.data.result;
                    } else {
                        self.busquedas = [].concat(self.busquedas, response.data.data.result);
                    }
                    self.LastEvaluatedKey2 = (response.data.data.LastEvaluatedKey) ? response.data.data.LastEvaluatedKey : null;
                    console.log('selectedSearch', self.selectedSearch);
                    if (self.selectedSearch) {
                        var found = false;
                        for (var i in self.busquedas) {
                            var busqueda = self.busquedas[i];
                            if (busqueda.key == self.selectedSearch) {
                                self.selectSearch(busqueda, i);
                                found = true;
                                break;
                            }
                        }
                        console.log('found', found);
                        console.log('self.LastEvaluatedKey2', self.LastEvaluatedKey2 != null, typeof self.LastEvaluatedKey2);
                        if (found == false && self.LastEvaluatedKey2 != null) {
                            self.getSearches();
                        }
                    }
                })
                .catch(function (error) {
                    self.error(error);
                });
        },
        hideSearches() {
            this.hide = !this.hide;
            if (this.hide) {
                this.label = "Mostrar Búsquedas";
                this.flecha = "caret-right"
            } else {
                this.label = "Ocultar Búsquedas";
                this.flecha = "caret-left"
            }
        },
        menuVisible(menu) {
            this.hide = true;
            this.menuOn = menu;
        },
        error(msg) {
            this.$snotify.clear();
            this.$snotify.error(msg, this.$store.state.error);
        },
        success(msg) {
            this.$snotify.clear();
            this.$snotify.success(msg, this.$store.state.success);
        },
        handleScroll: function () {
            const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
            if (currentScrollPosition == 0) {
                this.classTop = false;
            } else {
                this.classTop = true;
            }
        },
        //searches
        newSearch() {
            this.$store.commit('clearProyectConfig');
            this.customSearch = {};
            this.customIndexSearch = -1;
            this.clearNotas();
        },
        selectSearch(item, index, logs= false) {
            this.$store.commit('clearProyectConfig');
            this.customSearch = item;
            this.customSearch.logs = logs;
            this.customIndexSearch = index;
            this.clearNotas();
             //INICIALES-DEV
            this.view = 3;
            //
            this.editing = false;
            this.$store.dispatch('setSelectedSearch', item.key);
            this.loadItems();
            console.log('customSearch');
            console.log(this.customSearch);
        },
        clearNotas() {
            this.items = [];
            this.isEmpty = false;
            this.LastEvaluatedKey = 0;
            this.total = 0;
        },
        getKeywords(keywords) {
            var k = keywords.toString();
            return k;
        },
        //notas
        loadItems() {
            console.log('loadItems');
            console.log(this.customSearch);
            var self = this;
            var mi_query = this.customSearch.query;
            mi_query.limit = this.limit;
            mi_query.LastEvaluatedKey = this.LastEvaluatedKey;
            mi_query.token = this.token;
            mi_query.logs = this.customSearch.logs;
            console.log('miquery:')
            console.log(mi_query);
            axios.post(this.url + "queryElasticSearchV5", mi_query)
            //axios.post("https://szhujeoed5.execute-api.us-east-1.amazonaws.com/dev/queryElasticSearchV5", mi_query)
                .then(response => {

                    if (response.data.success) {

                        var query_result = response.data.data;
                        console.log(query_result);

                        var data = query_result;
                        console.log(data);
                        var arr_result = data.result;
                        console.log(arr_result);
                        self.total = data.total;
                        self.empty = self.total > 0 ? false : true;
                        self.LastEvaluatedKey =
                            self.limit + self.LastEvaluatedKey > self.total
                                ? -1
                                : self.limit + self.LastEvaluatedKey;
                        for (var j in arr_result) {
                            self.items = [].concat(self.items, arr_result[j]);
                        }
                        self.isEmpty = self.items.length > 0 ? false : true;
                        console.log('LastEvaluatedKey')
                        console.log(self.isEmpty )
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    self.isLoading = false;
                    self.error(error);
                });
        },
        setSelected(value) {
            this.view = value;
        },
        goToNote(obj) {
            var name = "";
            var fi = obj.fi ? obj.fi : obj.entrada;
            switch (fi) {
                case "FB":
                case "I":
                case "TW":
                    name = "notaEmbedded";
                    break;
                case "Y":
                    name = "notaYoutube";
                    break;
                case "PD":
                    name = "notaText";
                    break;
                case "T":
                case "R":
                    name = "notaVideo";
                    break;
                case "TK":
                    name = "notaTk";
                    break;
            }

            var p = { from: "busquedas", extraParams: { customSearch: this.customSearch, customIndexSearch: this.customIndexSearch } };
            this.$store.commit("saveBack2", p);

            var params = {
                id: obj.id ? obj.id : obj.key,
                fi: fi
            };
            if (obj.entrada == "TK") {
                params = {
                    fi: fi,
                    id: obj.key
                };
            }

            this.$router.push({ name: name, params: params });
        },
        goToNotes() {

        },
        loadMore() {
            if (this.LastEvaluatedKey == -1) {
                this.$snotify.info("Ya no ha más notas", "Info");
            } else {
                this.loadItems();
            }
        },
        //button tools
        borrarBusqueda() {
            this.show = true;
        },
        cancelDelete() {
            this.show = false;
        },
        deleteSearch() {
            console.log(this.customSearch ,"#########5444")
            var post_data = {
                key: this.customSearch.key,
                token: this.token
            };
            var self = this;
            axios.post(self.url + "deleteSearch", JSON.stringify(post_data))
                .then(response => {
                    self.show = false;
                    if (response.data.success) {
                        self.busquedas.splice(self.customIndexSearch, 1);
                        self.success('Búsqueda eliminada');
                       
                        if(self.customSearch.query.hasOwnProperty("alertWP")){
                            if(self.customSearch.query.alertWP){
                                self.deleteNotificationWP();
                            }
                            
                        }
                        self.customSearch = {};
                        self.customIndexSearch = -1;
                        self.clearNotas();

                    }
                })
                .catch(function (error) {
                    self.show = false;
                    self.error(error);
                });
        },
        deleteNotificationWP() {
            let key_notifica = this.customSearch.table+"_"+this.customSearch.key
  
            var post_data = {
                key: key_notifica,
                token: this.token,
               
            };
            var self = this;
            axios.post(this.url + "deleteConfigWa", JSON.stringify(post_data))
                .then(response => {
                    self.show = false;
                    if (response.data.success) {
                        self.success('Notificacion eliminada');
                    }
                })
                .catch(function (error) {
                    self.show = false;
                    self.error(error);
                });
        },
        //nueva busqueda
        buscar(query, notificationstatus) {
            this.notificationstatus = notificationstatus;
            //guardamos busuqeda
            console.log(query, "#####$$")
            this.saveSearch(query);
        },
        saveSearch(query) {
            query.alertWP = this.notificationstatus;
           
            var post_data = {
                token: this.token,
                query: query,

            };
            var self = this;
            //self.url
            console.log("////////////////")
            console.log(self.url)
            console.log("////////////////")
            axios.post(self.url + "saveSearch", JSON.stringify(post_data))
                .then(response => {
                    console.log('response saveSearch')
                    console.log(response);
                    if (response.data.success) {
                        self.busquedas.unshift(response.data.data);
                        self.customSearch = response.data.data;
                        self.customSearch.logs = true
                        self.customIndexSearch = 0;
                        self.$store.dispatch('setSelectedSearch', response.data.data.key);
                        if(this.notificationstatus){
                                console.log("ppp######",response.data.data);
                                var setNotific ={
                                    key_busqueda : response.data.data.key,
                                    table_busqueda :  response.data.data.table,
                                    action : "new",
                                    keywords : response.data.data.query.keywords,
                                    fuentes :  response.data.data.query.fi,
                                    active:true,
                                    frecuencia : 1
                                }
                                
                                this.$store.commit('setNotificacionWp', setNotific);
                            this.$router.push("/config-wa");
                        }else{
                            self.loadItems();
                        }
                       
                    }
                })
                .catch(function (error) {
                    self.error(error);
                });
        },
        //EXPORT FILE (IVAN)
        exportFile() {
            this.isActive = true;
        },
        closeModal() {
            this.isActive = false;
        },
        exportCSV(fName) {
            if (fName.fName.trim() == "") {
                this.error("Ingrese un Nombre");
                return 0;
            }
            this.closeModal();

            var that = this;
            var dat = JSON.stringify({
                token: that.token,
                query: that.customSearch.query,
                nombre: fName.fName,
                resumen : fName.fRes
            });
            axios
                .post(that.url + "downloadCSV", dat)
                .then(function (response) {
                    //console.log(response);
                    if (response.data.success == true) {
                        that.success(
                            "Se generó un nuevo archivo, en breve se encontrará en la sección de descargas",
                            "Success"
                        );
                    }
                })
                .catch(function (error) {
                    console.log("Error");
                    console.log(error);
                    that.error(error);
                });
        },
        //guarda en carpeta
        saveNotes() {

            var p = { from: "busquedas" };
            this.$store.commit("saveBack2", p);

            this.$router.push({
                name: "guardarEnCarpeta",
                params: {
                    query: this.customSearch.query
                }
            });
        },
        //titulo bartool
        getMedio() {
            var arr = [];
            var query = this.customSearch.query;
            if (query.fi.FB) {
                arr.push("Facebook")
            }
            /* if (query.fi.I) {
                 arr.push("Instagram")
             }*/
            if (query.fi.TW) {
                arr.push("Twitter")
            }
            if (query.fi.PD) {
                arr.push("Portales digitales")
            }
            if (query.fi.R) {
                arr.push("Radio")
            }
            if (query.fi.T) {
                arr.push("Televisión")
            }
            if (query.fi.Y) {
                arr.push("Youtube")
            }
            if (query.fi.TK) {
                arr.push("Tiktok")
            }

            return arr.toString();

        },
        getFechas() {
            console.log('getFechas');
            var query = this.customSearch.query;

            console.log(query.fecha);
            console.log(query.dias);
            if(query.dias == null && query.fecha == null){
                var dias = query.dias; //dias atrás
                var fecha = moment();
                var fechaFin = moment.tz(fecha, 'America/Mexico_City').format('DD/MM/YYYY');
                var fecha2 = fecha.subtract(dias - 1, 'days');
                var fechaInicio = moment.tz(fecha2, 'America/Mexico_City').format('DD/MM/YYYY');
                var f = fechaFin + ' - ' +  fechaInicio;
                console.log("con fecha en los parametros",query);
                return f;
            }

            if (!isNaN(query.dias)) {
                var dias = query.dias; //dias atrás
                var fecha = moment();
                var fechaFin = moment.tz(fecha, 'America/Mexico_City').format('DD/MM/YYYY');
                var fecha2 = fecha.subtract(dias - 1, 'days');
                var fechaInicio = moment.tz(fecha2, 'America/Mexico_City').format('DD/MM/YYYY');
                var f = fechaInicio + ' - ' + fechaFin;
                console.log("con fecha en los parametros",query);
                return f;
            }
            else {
                var fechaIni = "";
                var fechaFin = "";
                if (query.fecha.ini) {
                    var arr = query.fecha.ini.split('-');
                    var anio = arr[0];
                    var mes = parseInt(arr[1]);
                    if (mes <= 9) mes = '0' + mes;
                    var dia = parseInt(arr[2]);
                    if (dia <= 9) dia = '0' + dia;
                    fechaIni = dia + '/' + mes + '/' + anio;
                }
                if (query.fecha.fin) {
                    console.log("entro al if de la fecha fin");
                    var arr = query.fecha.fin.split('-');
                    var anio = arr[0];
                    var mes = parseInt(arr[1]);
                    if (mes <= 9) mes = '0' + mes;
                    var dia = parseInt(arr[2]);
                    if (dia <= 9) dia = '0' + dia;
                    fechaFin = dia + '/' + mes + '/' + anio;
                }
                console.log("sin fecha en los parametros",fechaIni + '-' + fechaFin);
                return fechaIni + '-' + fechaFin;
            }
            
            
        },
        //email
        enviar() {
            this.emailModal = true;
        },
        cancelarEnviar() {
            this.emailModal = false;
        },
        async sendEmail(obj) {
            var post_data = {
                token: this.token,
                query: this.customSearch.query,
                email: obj.email,
                type: "notas"
            };
            if (obj.subject != "") post_data["subject"] = obj.subject;

            if (obj.type == "correos") {

                if (obj.cc) post_data["cc"] = obj.cc;

                var self = this;

                axios.post(this.url + "sendMail", post_data)
                    .then(response => {
                        self.emailModal = false;
                        if (response.data.success) {
                            self.success("Email enviado");
                        } else {
                            self.error(response.data.error);
                        }
                    })
                    .catch(function (error) {
                        self.error(response.data.error);
                        //console.log(error);
                    });
            } else {
                console.log('grupos')
                post_data.type = "grupos";
                var r = await this.sendEmails(post_data);
                this.emailModal = false;
                if (r.success) {
                    this.success("Email enviado");
                } else {
                    this.error(r.error);
                }
            }
        },
        async sendEmails(obj) {
            var post_data = {
                query: obj.query,
                token: this.token,
                type: obj.type,  //correo o grupos?
                items: obj.email, //array de correos o grupos
            }

            if (obj.subject) post_data.subject = obj.subject;
            var self = this;
            return new Promise((resolve) => {
                axios.post(self.url + "sendEmails", JSON.stringify(post_data))
                    .then(function (response) {

                        console.log(response)
                        if (response.data.success)
                            resolve({ success: true })
                        else
                            resolve({ success: false, error: response.data.error })
                    })
                    .catch(function (error) {

                        resolve({ success: false, error: error })
                    });
            });
        },
        //edicion
        editarBusqueda() {
            this.editing = true;
            this.mode = 2;
            this.clearNotas();
        },
        update(data) {
            this.busquedas[this.customIndexSearch] = data;
            this.customSearch = data;
            this.selectSearch(this.customSearch, this.customIndexSearch,true);
        },
        getTotalLabel() {
            var label = this.total > 0 ? "(" + this.total + ")" : "";
            return label;
        },
        getFis(query) { //get fuentes de informacion para mostrar iconos en listado
            var fi = query.fi;
            var fiKeys = Object.keys(fi);
            return fiKeys;
        }
    }
}
</script>
<style scoped>
.checkAND label {
    width: 100%;
}

button[disabled],
html input[disabled] {
    cursor: default;
    background-color: #fff !important;
    border: 1px solid #00B99E;
    color: #062633 !important
}

.keywords-section .Keywords-input input {
    border: 1px solid #00B99E;
}

.keywords-section .Keywords-input input::placeholder {
    color: #062633;
}

.buttonTool {
    color: #fff;
    background: #00b99e;
    border-radius: 5px;
    border: none;
    padding: 5px 9px;
    font-size: 16px;
    z-index: 1000;
    max-height: 30px;
}

.buttonTool:hover {
    color: #062633;
    background: #ebf9ff;
    border-radius: 5px;
    border: none;
    padding: 5px 9px;
    font-size: 16px;
    z-index: 1000;
}

.button.tooltip:after {
    z-index: 1000;
}

#wrapper {
    padding-left: 250px;
    transition: all 0.4s ease 0s;
}

#sidebar-wrapper {
    margin-left: -250px;
    left: 250px;
    width: 250px;
    background: #062633;
    border-right: 1px solid #EBF9FF;
    position: fixed;

    overflow-y: scroll;
    overflow-x: hidden;

    z-index: 1000;
    transition: all 0.4s ease 0s;
    top: 60px;
    bottom: 0;
    scrollbar-width: thin;
    /* "auto" or "thin"  */
    scrollbar-color: #062633 #00B99E;
}

::-webkit-scrollbar {
    width: 12px;
}


::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 3px #00B99E;
    border-radius: 5px;
}

::-webkit-scrollbar-thumb {
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 3px #00B99E;
}

.top0 {
    top: 0px !important;
}

#wrapper.active {
    padding-left: 0;
}

#wrapper.active #sidebar-wrapper {
    left: 0;
}

#page-content-wrapper {
    width: 100%;
    transition: all 0.4s ease 0s;
}

.sidebar-nav {
    position: absolute;
    top: 0;
    width: 250px;
    list-style: none;
    margin: 0;
    padding: 0;
    min-height: 100%;
}


.sidebar-nav li {
    margin: auto;
    width: 98%;
    line-height: 20px;
}

.sidebar-nav li a {
    border: 1px solid #00b99e;
    margin: 5px;
    border-radius: 5px;
    color: #ebf9ff;
    display: block;
    text-decoration: none;
    text-indent: 5px;
    word-wrap: break-word;
    padding-top: 5px;
    padding-bottom: 5px;
}


.sidebar-nav li a span {
    margin-left: 1%;
}

.sidebar-nav li a span svg {
    fill: #ebf9ff;
}

.sidebar-nav li a span:before {
    position: absolute;
    left: 0;
    color: #ebf9ff;
    text-align: center;
    width: 20px;
    line-height: 18px;
}

.sidebar-nav li a:hover,
.sidebar-nav li.active {
    color: #ebf9ff;
    background-color: #00b99e;
    text-decoration: none;
}

.selected {
    color: #ebf9ff;
    background-color: #00b99e;
    text-decoration: none;
}

.sidebar-nav li a:active,
.sidebar-nav li a:focus {
    text-decoration: none;
}

.sidebar-nav>.sidebar-brand {
    margin-bottom: 2% !important;
    height: 40px;
    font-size: 18px;
    width: 95%;
    margin: auto;
    border-bottom: 1px solid #ebf9ff;
}

.sidebar-nav>.sidebar-brand a {
    border: none;
    cursor: default;
    color: #fff;
}

.sidebar-nav>.sidebar-brand a:hover {
    background: none;
    color: #fff;
    border: none
}

#menu-toggle {
    text-decoration: none;
    float: left;
    color: #fff;
    padding-right: 15px;
}

@media (max-width:767px) {

    #wrapper {
        padding-left: 0;
    }

    #sidebar-wrapper {
        left: 0;
    }

    #wrapper.active {
        position: relative;
        left: 250px;
    }

    #wrapper.active #sidebar-wrapper {
        left: 250px;
        width: 250px;
        transition: all 0.4s ease 0s;
    }

    #menu-toggle {
        display: inline-block;
    }

}

.dropdown {
    text-align: center;
}

.end {
    width: 100%;
    height: 40px;
    line-height: 20px !important;
    text-indent: 0px !important;
}

.icons {
    text-align: center;
}

.iconsTitle svg {
    margin-right: 1%;
    fill: #00b99e !important;
}
</style>